export default class CampaignsCollection {
  constructor(type, campaigns = [], sortFilter = 'campaigns.original_campaign_id:DESC') {
    this.type = type;
    this.campaigns = campaigns;
    this.page = 0;
    this.limit = 20;
    this.canLoad = true;
    this.initialized = false;
    this.searchQuery = '';
    this.total = 0;

    this.start = null;
    this.end = null;
    this.localStart = null;
    this.localEnd = null;
    this.dateType = null;

    this.sortFilter = sortFilter;
    this.productFilter = -1;
    this.statusFilter = 'All',
    this.domainFilter = -1;
    this.createdByFilter = -1;

    this.relaunchOption = 'All Time';
    this.ignoredCampaignIds = [];
  }
}